module.exports = __webpack_public_path__ + "static/media/Sunny_A.ab6a8fa9.jpg";